'use client';

import React from 'react';

import { ExtendedLink } from '@/components/ExtendedLink';

type Props = {
  href: string;
  title: string;
  className?: string;
  linkClassName?: string;
  children?: React.ReactNode;
};

function SitemapSecondaryCategory({
  href,
  title,
  children,
  className,
  linkClassName,
}: Props) {
  return (
    <li className={className}>
      <ExtendedLink href={href} prefetch={false} className={linkClassName}>
        {title}
      </ExtendedLink>

      {children && children}
    </li>
  );
}

export { SitemapSecondaryCategory };
